import React, { FC } from "react";
import UpgradeTeacherProForm from "../../components/UpgradeTeacherProForm";

const UpgradeTeacher: FC<{}> = (props: any) => {

  return (
    <>
      <UpgradeTeacherProForm environment={props.environment} entity={props.entity}/>
    </>
  );
}

export default UpgradeTeacher;
